import React from 'react';
import clsx from 'clsx';
import { Icon } from '@/components/common';
import Icons from '@/const/icons';

interface Props {
	isCompleted: boolean;
	type?: 'document-requested' | 'document-to-send';
	customIcon?: string;
}

export const IconStatus: React.FC<Props> = ({
	isCompleted,
	type = 'document-to-send',
	customIcon,
}) => {
	return (
		<div
			className={clsx(
				'flex items-center justify-center size-11 bg-grey-100 p-[10px] rounded-lg',
				{ 'bg-purple-35': isCompleted },
				{ '!bg-[#2084E726]': type === 'document-requested' }
			)}
		>
			<Icon
				src={
					customIcon
						? customIcon
						: type === 'document-requested'
						? Icons.documentDownloadBlue
						: Icons.documentText
				}
				className={clsx('!size-6 text-[#6E6A73]', {
					'text-primary': isCompleted,
					'!text-main-blue': type === 'document-requested',
				})}
			/>
		</div>
	);
};
